var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { attrs: { title: "Test CiinaboxDeployments Graph Card" } },
    [
      _c(
        "div",
        { staticClass: "summary-content" },
        [
          _vm.showGraph && _vm.graphReady && _vm.graphMetrics.length
            ? _c("DeploymentsGraph", {
                attrs: {
                  metrics: _vm.graphMetrics,
                  name: "Deployments",
                  date: _vm.currentDate,
                  id: _vm.entityId
                },
                on: { updateMetric: _vm.handleMetricUpdate }
              })
            : _vm.graphReady
            ? _c("div", { staticClass: "text-gray-500 text-sm italic mt-2" }, [
                _vm._v("\n  No deployments available to render graph.\n")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "kpi-section mt-4" }, [
            _c("h4", { staticClass: "text-lg font-semibold mb-2" }, [
              _vm._v("Current State")
            ]),
            _vm._v(" "),
            _c(
              "dl",
              { staticClass: "grid grid-cols-2 gap-2 text-sm" },
              [
                _c("dt", [_vm._v("Deployments Displayed")]),
                _vm._v(" "),
                _c("dd", [
                  _vm._v(
                    _vm._s(
                      _vm.filteredDeploymentCount !== null
                        ? _vm.filteredDeploymentCount
                        : "N/A"
                    )
                  )
                ]),
                _vm._v(" "),
                _vm.activeType === "group"
                  ? [
                      _c("dt", [_vm._v("Contracts")]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.contractCount !== null
                              ? _vm.contractCount
                              : "N/A"
                          )
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeType === "contract"
                  ? [
                      _c("dt", [_vm._v("Stacks")]),
                      _vm._v(" "),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.stackCount !== null ? _vm.stackCount : "N/A"
                          )
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeStack
                  ? [
                      _c("dt", [_vm._v("Filtering by Stack")]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.activeStack))])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("dt", [_vm._v("Reporting Period Ending")]),
                _vm._v(" "),
                _c("dd", [
                  _vm._v(_vm._s(_vm.formattedDate ? _vm.formattedDate : "N/A"))
                ])
              ],
              2
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-020f8294", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-020f8294","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/InfoCards/TestDeployments.vue
// module id = null
// module chunks = 